import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// Не из индекса фичи: он тянет экраны урока и упражнения. Здесь — только данные подборки.
import { useGrammarReviewQuery } from '@features/Grammar/model/queries';
import { trackEvent } from '@shared/analytics';
import { paths } from '@shared/config';
import { Button, RewardBadge, TokenIcon } from '@shared/ui';

/**
 * «Повтори грамматику» — строка плашки «На сегодня» (владелец 2026-10-25: «подборки тем, которые стоит повторить, — на
 * главный экран, и давать за них жетон»). Есть подборка — темы и «Повторить»; пройдена сегодня — полученный жетон.
 * Подборки нет — строки нет.
 */
export function ReviewRow() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const review = useGrammarReviewQuery().data;
  if (!review || (!review.available && !review.done_today) || (review.available && !review.items.length)) return null;

  const open = () => {
    trackEvent('home_review_clicked', { topics: review.topics.length });
    navigate(paths.grammarReview);
  };
  return (
    <div className="dl-row flex items-center gap-3">
      <span aria-hidden className="dl-art lx-px-sm grid h-12 w-12 flex-none place-items-center bg-[#2a2d55] font-serif text-[20px] font-semibold text-[#e6dcff]">
        Aa
      </span>
      <div className="dl-text min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[12px] font-semibold uppercase tracking-[0.12em] text-muted">
          {t('grammar.review.rowKicker')}
          {review.available && review.reward > 0 && (
            <span className="inline-flex items-center gap-1 rounded-pill bg-accent/15 px-1.5 py-0.5 text-[11px] font-semibold normal-case tracking-normal text-accent">
              <TokenIcon size={12} />
              {t('grammar.review.reward', { count: review.reward })}
            </span>
          )}
        </div>
        <h3 className="mt-0.5 line-clamp-2 break-words font-serif text-[17px] font-medium leading-[22px] text-fg">
          {/* Название темы до двоеточия: «Глагол to be», а не «Глагол to be: am, is, are» — строка короткая. */}
          {review.available ? review.topics.map((tp) => tp.title.split(':')[0]).join(', ') : t('grammar.review.rowDone')}
        </h3>
      </div>
      <div className="dl-action flex flex-none items-center gap-2">
        {review.available ? (
          <Button variant="outline" size="sm" onClick={open}>
            {t('grammar.review.rowAction')}
          </Button>
        ) : review.granted ? (
          <RewardBadge size="sm" amount={review.reward} caption={t('rewards.earned', { count: review.reward })} />
        ) : null}
      </div>
    </div>
  );
}
